import React, { useState,useEffect } from "react";
import "./ImageGallery.css";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import { FaCamera } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import axios from "axios";
import constant from "../constant/constant";
import SmallLoader from "./SmallLoader";

const ImageGallery = ({ setImageURL, ApiName }) => {
  const user = useSelector((state) => state.auth);
  const [media, setMedia] = useState([]);

  // const handleMediaUpload = (event) => {
  //   const files = event.target.files;
  //   const newMedia = [...media];

  //   for (const file of files) {
  //     newMedia.push({ type: file.type, url: URL.createObjectURL(file) });
  //   }

  //   setMedia(newMedia);
  // };

  // const handleMediaUpload = (event) => {
  //   const files = Array.from(event.target.files);
  //   const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
  //   const newImages = files
  //   .filter(file => imageTypes.includes(file.type))
  //   .map((file, index) => {
  //     return {
  //       id: Date.now() + index + 1+"_new",
  //       url: "",
  //       name: file.name,
  //       status: "1",
  //       file: file,
  //     };
  //   });
  //   newImages.forEach(image => {
  //     const formData = new FormData();
  //     formData.append('file', image.file);
  //      axios.post(`${constant.base_url}/review_student.php?fun=upload_images`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         "Auth-Id": user.auth_id
  //       },
  //     }).then(response => {
  //       let uploadedUrl = response.data.data.image.url;
  //       image.url = uploadedUrl;
  //       setMedia(uploadedUrl);
  //     })
  //     .catch(error => {
  //       console.error('Error uploading file:', error);
  //     });
  //   });
  // }

  const handleMediaUpload = (event) => {
    const files = Array.from(event.target.files);
    const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
    const newImages = files
      .filter(file => imageTypes.includes(file.type))
      .map((file, index) => {
        return {
          id: Date.now() + index + 1 + "_new",
          url: "",
          name: file.name,
          status: "1",
          file: file,
        };
      });
  
    Promise.all(newImages.map(image => {
      const formData = new FormData();
      formData.append('file', image.file);
      return axios.post(`${constant.base_url}/student/${ApiName}?fun=upload_images`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Auth-Id": user.auth_id
        },
      }).then(response => {
        const { name, url, type } = response.data.data.image;
        return {
          ...image,
          url: url,
          name: name,
          type: type
        };
      });
    }))
    .then(updatedImages => {
      setMedia(prevMedia => [...prevMedia, ...updatedImages]);
    })
    .catch(error => {
      console.error('Error uploading file:', error);
    });
  };

  
  const removeMedia = (index) => {
    const newMedia = [...media];
    newMedia.splice(index, 1);
    setMedia(newMedia);
  };

  // useEffect(() => {
  //   setImageURL(media);
  // }, [media, setImageURL]);

  useEffect(() => {
    console.log("Media:", media);
    setImageURL(media);
  }, [media, setImageURL]);  

  return (
    <>
      <div className="image-gallery df fww">
        <div className="media-card-container df fww w100">
          <label
            htmlFor="mediaInput"
            className="media-upload-button box-center pr fdc cp"
          >
            <span className="media-upload-icon">
              <FaCamera className="mb12 fc5 fs24 " />
            </span>{" "}
            <span className="fw5 fc6 fs16 ls1 cp">Add Photos</span>
          </label>
          <input
            type="file"
            id="mediaInput"
            multiple
            onChange={handleMediaUpload}
            accept="image/*, video/*"
            style={{ display: "none" }}
          />
        </div>
      </div>
      <div className="v-center fww">
        {media.map((item, index) => (      
          <div
            key={index}
            className={`media-card pr box-center ${
              (item.type && item.type.startsWith("image/")) ? "image-card" : "video-card"
            }`}
          >
            {item.type && item.type.startsWith("image/") ? (
              <img src={item.url} alt={`img ${index}`} />
            ) : (
              <video controls>
                <source src={item.url} type={item.type} />
                Your browser does not support the video tag.
              </video>
            )}
            <span
              className="remove-icon cp pa fs16"
              onClick={() => removeMedia(index)}
            >
              <AiOutlineClose />
            </span>
          </div>
        ))}

      </div>
    </>
  );
};

export default ImageGallery;
